import { render, staticRenderFns } from "./card-test.vue?vue&type=template&id=4ae2dbbd&scoped=true&"
import script from "./card-test.vue?vue&type=script&lang=js&"
export * from "./card-test.vue?vue&type=script&lang=js&"
import style0 from "./card-test.vue?vue&type=style&index=0&id=4ae2dbbd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae2dbbd",
  null
  
)

export default component.exports